export default __webpack_public_path__ + "static/media/metamask_new.cc5dfbce.svg";